<template lang="pug">
  div
    a.pull-right(v-if="editable" href="#" @click.prevent="openModal" data-testid="-link-edit-openflag") 編集
    h5 公開区分

    openflag-view(v-model="openflag", :class="{'bcard-field-editted': isFieldEditted}")

    portal(to="modal")
      //- 公開区分の変更
      app-modal(type="default" v-model="modalEdit.isOpen", data-testid="change-openflag-modal")
        template(slot="title") 公開区分の変更
        openflag-field(v-model="modalEdit.value")
        template(slot="footer" slot-scope="{close}")
          button.btn.btn-primary(type="button" @click.prevent="submit", data-testid="-btn-edit") 変更
          button.btn.btn-default(type="button" @click.prevent="close") キャンセル

      app-modal(v-model="modalError.isOpen" type="warning")
        template(slot="title") エラー
        h4 公開区分の変更に失敗しました。
        p(v-if="modalError.message") {{modalError.message}}
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import OpenflagView from '@/components/molecules/OpenflagView'
import OpenflagField from '@/components/molecules/OpenflagField'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'CardTabOverallOpenflag',
  components: { AppModal, OpenflagView, OpenflagField },
  props: {
    /**
     * @var openflag
     */
    value: { type: String, required: false, default: '' },
    sidPerson: { type: [String, Number], required: false, default: '' },
    editable: { type: Boolean, required: true } // ログインユーザーが唯一の交換者であること
  },
  data () {
    return {
      openflag: '',
      isFieldEditted: false,
      modalEdit: {
        isOpen: false,
        value: ''
      },
      modalError: {
        isOpen: false,
        message: ''
      }
    }
  },
  watch: {
    value (openflag) {
      if (openflag) {
        this.getData(openflag)
      }
    }
  },
  created () {
    if (this.value) {
      this.getData(this.value)
    }
  },
  methods: {
    getData (openflag) {
      this.openflag = openflag
    },
    openModal () {
      this.modalEdit.value = this.openflag
      this.modalEdit.isOpen = true
    },
    // 公開区分変更
    submit () {
      const vm = this
      const id = this.sidPerson
      const openflag = this.modalEdit.value
      this.isFieldEditted = false
      PersonRepository.putOpenflag(id, openflag, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.openflag = vm.modalEdit.value
            vm.showToast('公開区分を変更しました。', { type: 'success' })
            vm.modalEdit.isOpen = false
            vm.isFieldEditted = true
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          vm.modalError.message = error.message
          vm.modalError.isOpen = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabOverallOpenflag.vue